<template>
  <article class="venture-card" :class="{ featured: venture.featured }">
    <div class="card-header">
      <span class="status-pill">{{ venture.status }}</span>
      <h3>{{ venture.name }}</h3>
      <p class="tagline">{{ venture.tagline }}</p>
    </div>

    <p class="description">{{ venture.description }}</p>

    <ul class="focus-list">
      <li v-for="item in venture.focus" :key="item">{{ item }}</li>
    </ul>

    <component :is="linkTag" v-bind="linkProps" class="venture-link">
      {{ venture.ctaLabel }}
    </component>
  </article>
</template>

<script>
export default {
  name: 'VentureCard',
  props: {
    venture: {
      type: Object,
      required: true
    }
  },
  computed: {
    linkTag() {
      return this.venture.external ? 'a' : 'router-link';
    },
    linkProps() {
      return this.venture.external
        ? { href: this.venture.href, target: '_blank', rel: 'noopener noreferrer' }
        : { to: this.venture.href };
    }
  }
};
</script>

<style lang="scss" scoped>
@use "sass:color";
@use "@/assets/css/global.scss" as *;

.venture-card {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 2rem;
  border-radius: 24px;
  background: $surface-color;
  border: 1px solid $line-color;
  box-shadow: $shadow-md;
  transition: transform 0.25s ease, box-shadow 0.25s ease, border-color 0.25s ease;
}

.venture-card:hover {
  transform: translateY(-4px);
  box-shadow: $shadow-lg;
  border-color: rgba($accent-color, 0.18);
}

.venture-card.featured {
  background: linear-gradient(180deg, $surface-color, rgba($accent-color, 0.03));
}

.card-header h3 {
  margin-bottom: 0.6rem;
  color: $heading-color;
}

.status-pill {
  display: inline-flex;
  margin-bottom: 1rem;
  padding: 0.35rem 0.75rem;
  border-radius: 999px;
  background: rgba($accent-color, 0.08);
  color: $accent-color;
  font-size: 0.8rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
}

.tagline {
  margin-bottom: 1rem;
  color: $text-color;
  font-weight: 600;
}

.description {
  color: $text-muted;
}

.focus-list {
  display: flex;
  flex-wrap: wrap;
  gap: 0.65rem;
  margin: 0 0 1.5rem;
  padding: 0;
  list-style: none;
}

.focus-list li {
  padding: 0.45rem 0.75rem;
  border-radius: 999px;
  background: rgba($accent-purple, 0.08);
  font-size: 0.88rem;
  font-weight: 600;
  color: $text-color;
}

.venture-link {
  margin-top: auto;
  color: $accent-color;
  font-weight: 700;
  text-decoration: none;
}

.venture-link:hover {
  color: $heading-color;
  text-decoration: none;
}
</style>
